import React from 'react';
import styles from './RateSummaryOpportunities.module.scss';
import {RateSummaryOpportunityItem} from 'typing/dto';
import {RateSummaryAlertCard} from '../rate-summary-alert-card/RateSummaryAlertCard';

interface RateSummaryOpportunitiesProps {
    items: RateSummaryOpportunityItem[];
}

export const RateSummaryOpportunities: React.FC<RateSummaryOpportunitiesProps> = ({items}) => {
    return (
        <div className={styles.container}>
            {items.map((item, index) => (
                <RateSummaryAlertCard
                    key={index}
                    type="info"
                    item={{
                        title: item.title,
                        description: item.description,
                        tooltip: item.impact,
                        tooltipTitle: "Opportunities",
                        confidence: item.confidence
                    }}
                />
            ))}
        </div>
    );
}; 